<section id="main" class="bg-light">
     <div id="invoiceContainer" class="container">
          <h1 [innerHTML]="'RequestTokenHeader' | translator:'webservice'">Request an API Token</h1>
          <div class="row">
               <div id="billigReportContainer" class="col-lg-8">
                    <h2 class="h6 text-body fw-bold m-0" [innerHTML]="'WSToken_Overview' | translator:'webservice'">
                         Overview
                    </h2>
                    <p>
                         <span [innerHTML]="'WSToken_Overview_1' | translator:'webservice'">
                              The PSP REST API protocol leverage API tokens to access the PSP Web Service. Please view the PSP Web Service
                         </span>
                         <a [href]="updateUrl('##docBaseUrl##/FMCSA PSP-REST-WS_ProtocolImplementationGuide.pdf')"
                              target="_blank" 
                              id="linkAHManual" 
                              name="linkAHManual" 
                              role="button"
                              [innerHTML]="'WSToken_Overview_2' | translator:'webservice'"
                              [title]="'WSToken_Overview_2' | translator:'webservice'"
                         >Implementation Guide</a>
                         <span [innerHTML]="'WSToken_Overview_3' | translator:'webservice'">for additional details.</span>
                    </p>
                    <p [innerHTML]="'WSToken_Overview_4' | translator:'webservice'">
                         An API token can be requested at any time. Once obtained, you are responsible for ensuring the token is stored in a secure location.
                    </p>
                    <h2 class="h6 text-body fw-bold m-0" [innerHTML]="'WSToken_Overview_5' | translator:'webservice'">
                         Important information:
                    </h2>
                    <ul>
                         <li [innerHTML]="'WSToken_Overview_6' | translator:'webservice'">
                              The PSP REST web service leverages an API token in lieu of username/passwords. </li>
                         <li>
                              <span [innerHTML]="'WSToken_Overview_7a' | translator:'webservice'">
                                   To request an API token, you must have an approved PSP 
                              </span>
                              <span>Login.gov</span>
                              <span [innerHTML]="'WSToken_Overview_7c' | translator:'webservice'">
                               account.
                              </span>
                              <ul>
                                   <li [innerHTML]="'WSToken_Overview_8' | translator:'webservice'">
                                        Only primary and/or authorized users can request an API token. 
                                   </li>
                              </ul>
                         </li>
                         <li [innerHTML]="'WSToken_Overview_9' | translator:'webservice'">
                              A new API token can be requested at any time.
                         </li>
                         <li [innerHTML]="'WSToken_Overview_10' | translator:'webservice'">
                              Please make sure to download or copy the token code.
                         </li>
                         <li [innerHTML]="'WSToken_Overview_11' | translator:'webservice'">
                              You are responsible for ensuring the secure storage of your API Token.
                         </li>
                         <li [innerHTML]="'WSToken_Overview_12' | translator:'webservice'">
                              To ensure a high level of security, all requested token codes are masked after the initial request.
                         </li>
                         <li [innerHTML]="'WSToken_Overview_13' | translator:'webservice'">
                              If you have not saved or have lost your token code, you will need to request a new token.
                         </li>
                         <li [innerHTML]="'WSToken_Overview_14' | translator:'webservice'">
                              API tokens expire every 60-days from the day requested. 
                         </li>
                    </ul>

                    <p>
                         <button type="button" class="btn btn-primary btn-strong"
                              [title]="'WSToken_Overview_15' | translator:'webservice'"
                              [innerHTML]="'WSToken_Overview_15' | translator:'webservice'"
                              (click)="getToken()"
                              id="requestToken" name="requestToken"
                         >
                                   REQUEST AN API TOKEN 
                         </button>
                    </p>
                    <div *ngIf="tokenMasked !== ''" class="alert alert-success" role="alert">
                         <span [innerHTML]="'WSToken_Overview_16' | translator:'webservice'">
                              <b>Current token</b> ending in
                         </span>
                         <b>{{ tokenMasked }}&nbsp;</b>
                         <span [innerHTML]="'WSToken_Overview_17' | translator:'webservice'">
                              expires on
                         </span><b>{{ tokenExpires }}</b>.
                    </div>
               </div>
               <div class="col-lg-4 order-lg-2 sidebar">
                    <app-dashboardsupport></app-dashboardsupport>
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <h2 class="card-title h5 mt-0" [innerHTML]="'Resources' | translator:'base'">
                                   Resources
                              </h2>
                              <ul>
                                   <li *ngIf="companyType === 'MC'">
                                        <button (click)="openDocument('PSPMotorCarrierEnrollment')" target="_blank"
                                             class="btn btn-link"
                                             [title]="'MAHEnrollAgreement' | translator:'base'" 
                                             [innerHTML]="'MAHEnrollAgreement' | translator:'base'" 
                                             name="MAHagreement"
                                             id="MAHagreement"
                                        >
                                             PSP Monthly Account Holder Enrollment Agreement
                                        </button>
                                   </li>
                                   <li *ngIf="companyType === 'ISP'">
                                        <button (click)="openDocument('ISPAccountHolderAgreement')" target="_blank"
                                             class="btn btn-link"
                                             [title]="'ISPEnrollAgreement' | translator:'base'" 
                                             [innerHTML]="'ISPEnrollAgreement' | translator:'base'" 
                                             name="ISPagreement"
                                             id="ISPagreement"
                                        >
                                             PSP Industry Service Provider Enrollment Agreement
                                        </button>
                                   </li>
                                   <li>
                                        <button class="btn btn-link"
                                             [title]="'DisclosureAndAuth' | translator:'base'"
                                             [innerHTML]="'DisclosureAndAuth' | translator:'base'"
                                             (click)="openDocument('PSPDisclosureandAuthorizationForm')" target="_blank"
                                             title="Disclosure and Authorization Form" name="dna" id="dna"
                                        >
                                             Disclosure and Authorization Form
                                        </button>
                                   </li>
                                   <li>
                                        <button class="btn btn-link"
                                             [innerHTML]="'implementation-guide' | translator:'base'"
                                             [title]="'implementation-guide' | translator:'base'"
                                             (click)="openDocument('FMCSA PSP-REST-WS_ProtocolImplementationGuide')" target="_blank"
                                             name="dna" id="dna">PSP Web Service Implementation Guide</button>
                                   </li>
                                   <li>
                                        <a [href]="updateUrl('##baseUrl##/assets/XSL_StyleSheet_PSP_Driver_Report.xsl')"
                                             target="_blank" id="xslStylesheetLink" name="xslStylesheetLink" role="button"
                                             [innerHTML]="'xsl-stylesheet' | translator:'webservice'"
                                             [title]="'xsl-stylesheet' | translator:'webservice'">
                                             XSL Stylesheet
                                        </a>
                                   </li>
                              </ul>
                         </div>
                    </div>
               </div>
          </div>
     </div>
     <div class="overlay" *ngIf="requesting">
          <h1 class="heading" [innerHTML]="'WSToken_Overview_18' | translator:'webservice'">
               Getting Token
          </h1>
          <img />
     </div>
     <ng-template #showToken let-modal>
          <div class="modal-header">
               <h3 id="showTokenTitle" class="modal-title" [innerHTML]="'WSToken_Overview_19' | translator:'webservice'">
                    New API Token
               </h3>
          </div>
          <div class="modal-body">
               <div id="showToken">
                    <div class="m-0">
                         <div class="alert alert-success" role="alert" *ngIf="copied"
                              [innerHTML]="'WSToken_Overview_20' | translator:'webservice'"
                         >
                              Copied to clipboard 
                         </div>
                         <div class="alert alert-success" role="alert" *ngIf="isDownload"
                              [innerHTML]="'WSToken_Overview_21' | translator:'webservice'"
                         >
                              Download complete 
                         </div>
                         <div class="fw-bold" id="newTokenContent">{{ token }}</div>

                         <div class="italic fst-italic">
                              <span [innerHTML]="'WSToken_Overview_22' | translator:'webservice'">
                                   Token will expire on
                              </span>{{ tokenExpires }}.
                         </div>
                         <div class="italic fst-italic mt-3" [innerHTML]="'WSToken_Overview_23' | translator:'webservice'">
                              Please copy or download this token.
                         </div>
                    </div>
               </div>
          </div>
          <div class="modal-footer">
               <button class="btn btn-primary me-2" 
                    [title]="'WSToken_Overview_26' | translator:'webservice'"
                    id="bunDownload"
                    name="bunDownload" 
                    (click)="download()"
               >
                    <span [innerHTML]="'WSToken_Overview_26' | translator:'webservice'">Download</span>
               </button>                     
               <button class="btn btn-outline-primary me-2" 
                    [title]="'WSToken_Overview_25' | translator:'webservice'"
                    id="bunCopy" 
                    name="bunCopy"
                    (click)="copyDivToClipboard()"
               >
                    <span [innerHTML]="'WSToken_Overview_25' | translator:'webservice'">Copy</span>
               </button>         
               <button *ngIf="isDownload == true || copied === true" class="btn btn-outline-primary me-2"
                    (click)="closeToken()" 
                    [title]="'WSToken_Overview_24' | translator:'webservice'"
                    id="bunClose" name="bunClose">
                    <span [innerHTML]="'WSToken_Overview_24' | translator:'webservice'">Close</span>
               </button>
          </div>
     </ng-template>
</section>